<template>
  <div v-show="listfullscreen" class="menu" v-if="menuSlide === 'max'">
    <div class="logo">
      <img src="@/assets/images/menu-logo.png" alt="" />
    </div>
    <div class="menuInner">
      <ul class="lists">
        <template v-for="(idx, key) in list">
          <li
            :key="key"
            v-if="idx.auth.length == 0 || idx.auth.includes(userRole)"
          >
            <h4 class="title">
              <img :src="idx.url" :alt="idx.title" />
              <span>{{ idx.title }}</span>
            </h4>
            <div class="subtits">
              <template v-for="(index, key2) in idx.menus">
                <template
                  v-if="index.auth.length == 0 || index.auth.includes(userRole)"
                >
                  <p class="twrap" :key="key2" @click="clickMenu(index.url)">
                    <span
                      :name="index.title"
                      :class="{
                        current: [...index.current, index.url].includes(
                          curPath
                        ),
                      }"
                      >{{ index.title }}</span
                    >
                  </p>
                </template>
              </template>
            </div>
          </li>
        </template>
      </ul>
    </div>

    <!-- 伸缩按钮 -->
    <div class="iconSlide" id="iconSlidemax" @click="menuSlide = 'min'">
      <img src="@/assets/images/icon-ml.png" alt="" />
    </div>
  </div>

  <div v-show="listfullscreen" class="menu menuMin" v-else>
    <div class="logo">
      <img src="@/assets/images/menu-logo.png" alt="" />
    </div>
    <ul class="lists">
      <template v-for="(idx, key) in list">
        <li
          :key="key"
          v-if="idx.auth.length == 0 || idx.auth.includes(userRole)"
        >
          <h4 class="title">
            <img :src="idx.url" :alt="idx.title" />
          </h4>
          <div class="subtits">
            <template v-for="(index, key2) in idx.menus">
              <template
                v-if="index.auth.length == 0 || index.auth.includes(userRole)"
              >
                <span
                  :key="key2"
                  :class="{
                    current: [...index.current, index.url].includes(curPath),
                  }"
                  @click="clickMenu(index.url)"
                  >{{ index.title }}</span
                >
              </template>
            </template>

            <!-- <span
            :class="[{ current: curPath === '/bulletin/detection' }]"
            @click="clickMenu('/bulletin/detection')"
            >设备监测</span
          > -->
          </div>
        </li>
      </template>
    </ul>
    <div class="iconSlide" id="iconSlidemin" @click="menuSlide = 'max'">
      <img src="@/assets/images/icon-mr.png" alt="" />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import toRoleName from "@/mixins/roleName";
import env from "@/mixins/env";
import { mapState } from "vuex";
import Base64 from "@/util/encryptlong";
export default {
  name: "allmenu",
  mixins: [toRoleName, env],
  props: {
    screenWidth: Number,
    curPath: String,
  },
  data() {
    return {
      userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
      userRole: null,
      menuSlide: "max",
      theme: "primary",
      lastPath: "",
    };
  },
  components: {},
  computed: {
    uRights() {
      return this.$store.state.userRights;
    },
    currentm() {
      var cur = (this.$route.path && this.$route.path.split("/")) || [];
      if (cur.length > 3) {
        return "/" + cur[1] + "/" + cur[2] + "/" + cur[3];
      } else {
        return this.$route.path;
      }
    },
    listfullscreen() {
      return this.$store.state.fullsreeen;
    },
    list: function () {
      return [
        {
          title: "看板",
          url: require("@/assets/images/micon/icon-home.png"),
          auth: [],
          menus: [
            {
              title: "润滑点监测",
              url: "/index",
              current: ["/business/rhlist/"],
              auth: [],
            },
            {
              title: "设备监测",
              url: "/bulletin/detection",
              current: [],
              auth: [],
            },
          ],
        },
        {
          title: "业务管理",
          url: require("@/assets/images/micon/icon-business.png"),
          auth: [],
          menus: [
            {
              title: "设备管理",
              url: "/business/equipmentlist",
              current: ["/business/rhlist/"],
              auth: [],
            },
            {
              title: "润滑点管理",
              url: "/business/rhlist",
              current: ["/warning/record/"],
              auth: [],
            },
            {
              title: "经销商管理",
              url: "/business/dealerlist",
              current: [],
              auth: ["m1", "m0", "m3", "m4"],
            },
            {
              title: "客户管理",
              url: "/business/customerlist",
              current: [],
              auth: ["m1", "m0", "m3", "m4", "a1", "a0"],
            },
            {
              title: "网关管理",
              url: "/knowledge/gateway",
              current: [],
              auth: ["m1", "m0", "m3", "m4", "c0", "c1"],
            },
           
          ],
        },
        {
          title: "业务配置",
          url: require("@/assets/images/micon/icon-knowledge.png"),
          auth: ["m1", "m0", "m3", "m4", "c0", "c1"],
          menus: [
            {
              title: "行业配置",
              url: "/knowledge/industry",
              current: [],
              auth: ["m1"],
            },
            {
              title: "油品配置",
              url: "/knowledge/oil",
              current: [],
              auth: ["m1"],
            },
            {
              title: "设备类型配置",
              url: "/knowledge/equiptype",
              current: [],
              auth: ["m1"],
            },
            {
              title: "监测装置管理",
              url: "/knowledge/device",
              current: [],
              auth: [],
            },
             {
              title: "点表管理",
              url: "/business/poinrlist",
              current: [],
              auth: ["m1", ],
            },
          ],
          
        },
        {
          title: "租户管理",
          url: require("@/assets/images/micon/icon-hire.png"),
          auth: ["m1"],
          menus: [
            {
              title: "租户管理",
              url: "/hire/hiremanager",
              current: [],
              auth: ["m1"],
            },
          ],
        },
        {
          title: ["m1", "m0", "m3", "m4"].includes(this.userRole)
            ? "运营大盘"
            : "数据",
          url: require("@/assets/images/micon/icon-datas.png"),
          auth: [],
          menus: [
            {
              title: "数据大盘",
              url: "/operate/datas",
              current: [],
              auth: ["m1", "m0", "m3", "m4"],
            },
            {
              title: "统计分析",
              url: "/operate/analysis",
              current: [],
              auth: [],
            },
            {
              title: "数据导出",
              url: "/operate/dataexprt",
              current: [],
              auth: [],
            },
          ],
        },
        {
          title: "报警与诊断",
          url: require("@/assets/images/micon/icon-warning.png"),
          auth: [],
          menus: [
            {
              title: "诊断报告",
              url: "/warning/diagnostic",
              current: ["/business/lookdiaticreport"],
              auth: [],
            },
            {
              title: "历史报警记录",
              url: "/warning/recordlist",
              current: ["/warning/record"],
              auth: [],
            },
            {
              title: "润滑点台账",
              url: "/warning/standingBooklist",
              current: [],
              auth: [],
            },
            {
              title: "故障管理",
              url: "/knowledge/faultmanagement",
              current: [],
              auth: ["m1", "m0", "m3", "m4"],
            },
          ],
        },
        {
          title: "账号管理",
          url: require("@/assets/images/micon/icon-account.png"),
          auth: ["m1", "m0", "m3", "m4"],
          menus: [
            {
              title: "美孚账号管理",
              url: "/account/meifu",
              current: [],
              auth: ["m1"],
            },
            {
              title: "经销商账号管理",
              url: "/account/dealer",
              current: [],
              auth: ["m1"],
            },
            {
              title: "客户账号管理",
              url: "/account/customer",
              current: [],
              auth: ["m1", "m0", "m3", "m4"],
            },
          ],
        },
        {
          title: "系统",
          url: require("@/assets/images/micon/icon-sys.png"),
          auth: ["c1", "a1"],
          menus: [
            {
              title: "账号管理",
              url: "/system/account",
              current: [],
              auth: [],
            },
            {
              title: "注册审批",
              url: "/system/register",
              current: [],
              auth: [],
            },
            {
              title: "经销商授权管理",
              url: "/system/auth",
              current: [],
              auth: ["c1"],
            },
          ],
        },
        {
          title: "系统管理",
          url: require("@/assets/images/micon/icon-sys.png"),
          auth: ["m1", "c1", "m3", "m4"],
          menus: [
            {
              title: "用户协议",
              url: "/system/useragreement",
              current: [],
              auth: ["m1"],
            },
            {
              title: "公告编辑",
              url: "/system/notice",
              current: [],
              auth: ["m1"],
            },
            {
              title: "版本更新",
              url: "/system/versionRecord",
              current: [],
              auth: ["m1"],
            },
            {
              title: "操作日志",
              url: "/system/log",
              current: [],
              auth: [],
            },
          ],
        },
      ];
    },
  },
  activated() {},
  mounted() {
    this.getMenuSize(1);
    this.userRole = this.userInfo.authority;
    const role = this.toRoleName(this.userRole);
    if (this.userRole) ls.set("userRole", role);
  },
  methods: {
    clickMenu(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    developing() {
      this.$Message.info("开发中...");
    },
    getRights() {
      //用户权限
      api
        .axs("post", "/role/queryRoleAndMenuLinks", {
          roleId: ls.get("roleid"),
        })
        .then(({ data }) => {
          if (data.code === "SUCCESS") {
          }
        });
    },
    getMenuSize(indx = 0) {
      // np, op
      let allPaths = ls.get("allPaths") || [];
      if (allPaths.length) this.lastPath = allPaths[1] || "";

      // 有些页面table比较长 菜单栏需要收缩! 奇葩需求...
      let showMini = [
        "/bulletin/detection",
        "/business/rhlist",
        "/business/sensorlist",
        "/warning/recordlist",
        "/operate/datas",
        "/knowledge/faultmanagement",
      ];
      if (showMini.indexOf(this.curPath) > -1) this.menuSlide = "mini";
      else this.menuSlide = "max";

      if (indx == 1) {
        this.$store.commit("pub/setmenuSlide", this.menuSlide);
      }
    },
  },
  watch: {
    $route() {
      this.getMenuSize();
    },
    screenWidth: {
      immediate: true,
      handler(newValue) {
        newValue < 1450 ? (this.menuSlide = "min") : (this.menuSlide = "max");
      },
    },
    menuSlide(value) {
      this.$store.commit("pub/setmenuSlide", value);
    },
  },
};
</script>

<style lang="less">
.menu {
  flex: 0 0 232px;
  height: 100%;
  text-align: left;
  background-color: #0c479d;
  overflow: hidden;
  z-index: 102;

  .menuInner {
    // width: 265px;
    height: 90%;
    padding-left: 20px;
    padding-right: 20px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .logo {
    width: 124.88px;
    height: 43.68px;
    margin: 17px auto 20px;
    overflow: hidden;
    text-align: center;

    img {
      width: 100%;
    }
  }

  .lists {
    li {
      color: #fff;
      padding: 10px 0 4px;
      margin-bottom: 10px;
      border-bottom: 1px solid #37659f;

      &:last-child {
        border: none;
      }

      h4.title {
        display: flex;
        font-size: 16px;

        img {
          display: inline-block;
          height: 24px;
        }

        span {
          padding: 0 6px;
          margin-top: 1px;
        }
      }

      .subtits {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 0;

        .twrap {
          flex: 0 0 50%;

          span {
            display: inline-block;
            cursor: pointer;
            margin: 4px 0;
            font-size: 12px;
            color: #fff;
            border-radius: 4px;
            padding: 4px;

            &.current {
              background-color: #4272b9;
            }

            &:hover {
              background-color: #84a9e1;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }

  .iconSlide {
    position: absolute;
    top: 40%;
    left: 233px;
    width: 16px;
    height: 66px;
    cursor: pointer;

    &:hover {
      width: 16px;
    }

    img {
      width: 100%;
    }
  }
}

.menuMin {
  flex: 0 0 60px;
  padding: 0;
  overflow: initial;

  .logo {
    width: 49px;
    height: 27px;
    overflow: hidden;
    position: relative;

    img {
      width: auto;
      height: 100%;
      position: absolute;
      left: 0;
      clip: rect(0px, 47px, 18px, 0px);
    }
  }

  .lists {
    li {
      position: relative;
      border: none;
      padding: 14px 0;
      cursor: pointer;

      h4.title {
        text-align: center;

        img {
          margin: 0 auto;
        }
      }

      .subtits {
        display: none;
        position: absolute;
        left: 60px;
        top: 0;
        z-index: 99;
        opacity: 0.9;
        background-color: #6692d4;
        padding: 0;
        // width: 120px;
        // min-width: 100px;
        // max-width: 130px;

        span {
          display: block;
          padding: 20px 20px 16px 14px;
          margin: 0 !important;
          font-size: 14px;
          line-height: 16px;
          border-radius: 0;
          white-space: nowrap;

          &:hover {
            font-weight: bold;
            text-shadow: 1px 1px 1px #396ebd;
          }

          &.tcenter {
            text-align: center;
          }

          &.sline {
            border-bottom: 1px solid #fff;
          }

          &.w130 {
            width: 130px;
          }

          &.w120 {
            width: 130px;
          }

          &.w110 {
            width: 110px;
          }

          &.w100 {
            width: 100px;
          }

          &.w80 {
            width: 80px;
          }

          &.w60 {
            width: 60px;
          }

          &.w50 {
            width: 50px;
          }

          &.w30 {
            width: 30px;
          }
        }
      }

      &:hover {
        background-color: #6692d4;

        .subtits {
          display: block;
        }
      }
    }
  }

  .iconSlide {
    top: 38%;
    left: 60px;
  }
}
</style>
